import { gql } from '/apps/portal/src/generated/portal/gql';

const CREATE_INTERNAL_USER_ACCESS_REQUEST = gql(`
  mutation createInternalUserAccessRequest($input: InternalUserAccessRequestInput!) {
    createInternalUserAccessRequest(input: $input) {
      email
      requester
      businessJustification
      rostrLink
      requester
    }
  }
`);

export { CREATE_INTERNAL_USER_ACCESS_REQUEST };
